"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioRow = void 0;
var react_1 = __importDefault(require("react"));
var fieldStyles = __importStar(require("./Field.pc"));
var formik_1 = require("formik");
var styled_1 = __importDefault(require("@emotion/styled"));
var _1 = require(".");
var theme_1 = require("./theme");
/**
 * Input for a collection of radio button options. Must be wrapped in a Formik provider.
 * https://www.figma.com/file/5otfo5aNKz5sgwGJZxCXrP/WIP-Pallet-DS2022?node-id=21%3A1287
 * @param {string} name - The field name, used as reference by formik
 * @param {string} label - Section label for the collection of radio options, used to provide context to the user
 * @param {boolean=} disabled - Prevents interaction with the radio input
 * @param {Array<Option>} options - Array of radio button options
 * @param {Function=} onChange - Callback function when the value of the field changes
 * @param {Object} options.label - Descriptive label for each radio option, used to provide context to the user
 * @param {Object} options.value - String value for each radio option
 */
var RadioRow = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var _b = (0, formik_1.useField)(props), field = _b[0], meta = _b[1], helpers = _b[2];
    return (react_1.default.createElement(fieldStyles.View, { className: className, label: props.label, errorMessage: meta.touched ? meta.error : undefined },
        react_1.default.createElement(Column, null, props.options.map(function (option, index) {
            var isDisabled = props.disabled || !!option.disabled;
            return (react_1.default.createElement(Label, { disabled: isDisabled, key: "RadioRow_Label_".concat(index) },
                react_1.default.createElement(Radio, { type: "radio", name: props.name, value: option.value, disabled: isDisabled, themed: props.themed, onChange: function (e) {
                        if (props.onChange)
                            props.onChange(e);
                        field.onChange(e);
                    } }),
                react_1.default.createElement(RadioDisplay, null),
                react_1.default.createElement(_1.Text, { variant: "paragraphMedium" }, option.label)));
        }))));
};
exports.RadioRow = RadioRow;
var Column = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  & label {\n    margin-bottom: 8px;\n  }\n  & label:last-child {\n    margin-bottom: 0px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  & label {\n    margin-bottom: 8px;\n  }\n  & label:last-child {\n    margin-bottom: 0px;\n  }\n"])));
var Label = styled_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled && "opacity: 0.5;";
});
var RadioDisplay = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  content: \"\";\n  margin-right: 12px;\n  display: block;\n  border-radius: 50%;\n  box-sizing: border-box;\n  box-shadow: inset 0 0 0 1px ", ";\n"], ["\n  content: \"\";\n  margin-right: 12px;\n  display: block;\n  border-radius: 50%;\n  box-sizing: border-box;\n  box-shadow: inset 0 0 0 1px ", ";\n"])), theme_1.theme.colors.gray400);
var Radio = (0, styled_1.default)(formik_1.Field)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  appearance: none;\n  opacity: 0;\n  & + span {\n    min-width: 24px;\n    min-height: 24px;\n  }\n  &:checked + span {\n    box-shadow: inset 0 0 0 8px\n      ", ";\n  }\n  &:hover + span {\n    cursor: pointer;\n  }\n  &:checked:hover + span {\n    ", ";\n  }\n  &:disabled:hover + span {\n    box-shadow: inset 0 0 0 1px ", ";\n    border: none;\n  }\n  &:disabled:checked + span {\n    border: none;\n    box-shadow: inset 0 0 0 8px\n      ", ";\n  }\n"], ["\n  position: absolute;\n  appearance: none;\n  opacity: 0;\n  & + span {\n    min-width: 24px;\n    min-height: 24px;\n  }\n  &:checked + span {\n    box-shadow: inset 0 0 0 8px\n      ", ";\n  }\n  &:hover + span {\n    cursor: pointer;\n  }\n  &:checked:hover + span {\n    ", ";\n  }\n  &:disabled:hover + span {\n    box-shadow: inset 0 0 0 1px ", ";\n    border: none;\n  }\n  &:disabled:checked + span {\n    border: none;\n    box-shadow: inset 0 0 0 8px\n      ", ";\n  }\n"])), function (_a) {
    var _b;
    var themed = _a.themed, theme = _a.theme;
    return themed ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary : theme_1.theme.colors.gold200;
}, function (_a) {
    var _b;
    var themed = _a.themed, theme = _a.theme;
    return themed ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary : theme_1.theme.colors.gold200;
}, theme_1.theme.colors.gray400, function (_a) {
    var _b;
    var themed = _a.themed, theme = _a.theme;
    return themed ? (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary : theme_1.theme.colors.gold200;
});
exports.default = exports.RadioRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
